import React from "react";
import { Label } from "@/components/ui/label";
import { MessageCircle, Video } from "lucide-react";

const OPTIONS = [
  { v: "whatsapp", label: "WhatsApp call", icon: MessageCircle, sub: "Voice or video via WhatsApp" },
  { v: "google_meet", label: "Google Meet", icon: Video, sub: "Video call — link sent to your email" },
];

export const MeetingMethodPicker = ({ value, onChange }) => (
  <div>
    <Label className="text-xs uppercase tracking-[0.18em] text-[var(--gg-text-muted)] font-semibold">
      How would you like to meet? <span className="text-[var(--gg-primary)]">*</span>
    </Label>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-3">
      {OPTIONS.map((o) => {
        const Icon = o.icon;
        const active = value === o.v;
        return (
          <button
            type="button"
            key={o.v}
            onClick={() => onChange(o.v)}
            data-testid={`method-${o.v}`}
            className={`text-left rounded-xl border p-4 flex gap-3 transition-colors ${
              active
                ? "border-[var(--gg-primary)] bg-[var(--gg-primary)]/5 ring-2 ring-[var(--gg-primary)]/30"
                : "border-[var(--gg-border)] hover:border-[var(--gg-primary)]/60"
            }`}
          >
            <span className={`w-10 h-10 rounded-full flex items-center justify-center ${active ? "bg-[var(--gg-primary)] text-white" : "bg-[var(--gg-primary)]/10 text-[var(--gg-primary)]"}`}>
              <Icon size={18} />
            </span>
            <div>
              <div className="font-serif text-lg text-[var(--gg-deep)] font-semibold">{o.label}</div>
              <div className="text-sm text-[var(--gg-text-muted)]">{o.sub}</div>
            </div>
          </button>
        );
      })}
    </div>
  </div>
);
